<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12" md="8" sm="8">
        <div class="text-center">
          <v-btn-toggle rounded v-model="toggleStatus">
            <v-btn v-for="(t, index) in toggles" :key="index" :class="t.color + '--text'" style="width: 120px">{{ $t(t.type == 'order' ? 'ordered' : t.type) }}</v-btn>
          </v-btn-toggle>
        </div>
      </v-col>

      <v-col cols="12" md="4" sm="4">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <div class="text-center">
          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
          ></v-pagination>
        </div>
      </v-col>

      <v-col
        v-for="(orderDoc,ind) in transactionOrderList"
        :key="ind"
        cols="12"
        md="3"
        sm="4"
      >
        <v-card>
          <v-card-text>
            <table>

               <tr v-if="isOperator">
                <td>{{ $t('supplier') }}</td>
                <td> : </td>
                <td> <h3>{{ orderDoc.supplier_name }}</h3> </td>
              </tr>

              <tr>
                <td>{{ $t('client') }}</td>
                <td> : </td>
                <td> <h3>{{ orderDoc.client_name }}</h3> </td>
              </tr>

              <tr>
                <td style=" vertical-align: top">{{ $t('address') }}</td>
                <td style=" vertical-align: top"> : </td>
                <td style="white-space: normal">{{ orderDoc.client_full_location }}</td>
              </tr>

              <tr>
                <td>{{ $t('phone') }}</td>
                <td> : </td>
                <td> {{ orderDoc.client_phone | formatPhoneNumber }}</td>
              </tr>

              <tr>
                <td>{{ $t('reference') }}</td>
                <td> : </td>
                <td> {{ orderDoc.reference }}</td>
              </tr>

              <tr>
                <td>{{ $t('date') }}</td>
                <td> : </td>
                <td> {{ orderDoc.date }}</td>
              </tr>

              <tr>
                <td>{{ $t('totalAmount') }}</td>
                <td> : </td>
                <td> <h3>{{ parseFloat(orderDoc.total_amount) | formatNumber }}{{getCurrencySymbol(orderDoc.currency_code) }} </h3></td>
              </tr>
             
            </table>

            <v-progress-linear
              v-if="orderDoc.status === 'accepted' || orderDoc.status === 'partial'"
              :value="calculatePercentReceive(orderDoc.transaction_order_line)"
              height="13"
              striped
              class="mt-2"
            >
              <strong style="color: white">{{ Math.ceil(calculatePercentReceive(orderDoc.transaction_order_line)) }}%</strong>
            </v-progress-linear>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pr-4 pl-4">
            <v-spacer></v-spacer>
              <v-btn rounded small v-if="orderDoc.status!=='partial'" color="primary" @click="handleShowDetail(orderDoc)">
              {{ $t('viewDetail') }}
            </v-btn>
            <v-btn rounded small v-if="orderDoc.status==='accepted' || orderDoc.status=='partial'" color="success" @click="handleDeliverNote(orderDoc)">
              {{$t('deliveryNote')}}
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDetail" persistent width="700" :fullscreen="$vuetify.breakpoint.mobile">
      <detail po-type="sale" :po-doc="detailDoc" v-if="dialogDetail" :show-btn="(detailDoc.status =='completed' || detailDoc.status == 'accepted')  ? false : true" @handleApprovedOrRejected="handleApprovedOrRejected"></detail>
    </v-dialog>
    <v-dialog v-model="dialogDeliveryNote" persistent fullscreen>
      <delivery-note :po-doc="detailDoc" v-if="dialogDeliveryNote" :is-edit="false" @handleCreateDeliveryNote="handleCreateDeliveryNote"></delivery-note>
    </v-dialog>
  </div>
</template>
<script>

import OptionDataMixin from "../../../mixins/optionDataMixin";
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import Detail from "./detail";
import DeliveryNote from "./deliveryNote";
import {provider} from "@/service/provider";
import axios from "axios";
import math from "math";
import _ from "lodash";
export default {
  mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
  components: {Detail, DeliveryNote},
  data() {
    return {
      toggles: [
        { type: 'order', color: 'teal' },
        { type: 'accepted', color: 'primary' },
        { type: 'partial', color: 'warning' },
        { type: 'declined', color: 'error' },
        { type: 'completed', color: 'success' }
      ],

      search:"",
      dialogDetail: false,
      dialogDeliveryNote: false,
      detailDoc: {},
      toggleStatus: 0,
      tmpStatus: "order"
    };
  },
  methods: {
    calculatePercentReceive(list) {

      let order_qty = 0;
      let accepted_qty = 0;
      list.forEach((obj) => {
        order_qty += parseFloat(obj.order_qty || 0);
        accepted_qty += parseFloat(obj.accepted_qty || 0);
      })
      let percentTageReceive = math.round((accepted_qty/order_qty)*100);
      return percentTageReceive;
    },


    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchTransactionOrder({
        search: vm.search,
        id: "",
        offset: vm.skip || 0,
        limit: vm.itemsPerPage + (vm.skip || 0),
        sortBy: "created_at",
        sortDesc: 1,
        status: vm.tmpStatus,
        typeOrder: "sale_order",
        from_date: '',
        to_date: ''
      })
    }, 700),
    handleApprovedOrRejected() {
      let vm = this;
      vm.dialogDetail = false;
     vm.fetchDataTable();
    },
    handleCreateDeliveryNote() {
      let vm = this;
      vm.dialogDeliveryNote = false;
      vm.fetchDataTable();

    },
    handleShowDetail(doc) {
      let vm = this;
      vm.detailDoc = {};
      let url = provider.baseURL + provider.getTransactionOrder;
      return new Promise((resolve, reject) => {
        axios.post(url, {
          search: "",
          id: doc.id,
          contact_id: "",
          type_order: "",
          offset: 0,
          sort_by: "created_at",
          sort_desc: 1,
          limit: 1,
          from_date:'',
          to_date: ''
        }, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                let newItem = res.data.data[0];
                vm.detailDoc = Object.assign({}, newItem);
                vm.detailDoc.transaction_order_line.map((d) => {
                  d.currency_code = vm.detailDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(d.currency_code);
                  d.order_qty = parseFloat(d.order_qty);
                  d.price = parseFloat(d.price);
                  d.total_amount = parseFloat(d.total_amount);
                  return d;
                })
                vm.$nextTick(() => {
                  vm.dialogDetail = true;
                })
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },
    handleDeliverNote(doc) {
      let vm = this;
      let url = provider.baseURL + provider.getTransactionOrder;
      return new Promise((resolve, reject) => {
        axios.post(url, {
          search: "",
          id: doc.id,
          contact_id: "",
          offset: 0,
          type_order: "",
          sort_by: "created_at",
          sort_desc: 1,
          limit: 1,
          from_date: '',
          to_date: ''
        }, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                vm.detailDoc = {};
                resolve(res.data.data);
                let newItem = res.data.data[0];
                vm.detailDoc = newItem;
                vm.detailDoc.transaction_order_id = newItem.id;
                vm.detailDoc.total_amount = parseFloat(vm.detailDoc.total_amount);
                vm.detailDoc.deliverPercent = 0;
                vm.detailDoc.transaction_order_line.map((d) => {
                  d.currency_code = vm.detailDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(d.currency_code);
                  d.order_qty = parseFloat(d.order_qty);
                  d.price = parseFloat(d.price);
                  d.total_amount = parseFloat(d.total_amount);
                  return d;
                })
                vm.$nextTick(() => {
                  vm.dialogDeliveryNote = true;
                })
              }
            },
            error => {
              reject(error);
            }
        );
      });
    }

  },
  watch: {
    toggleStatus(val) {
      let vm = this;
      switch(val){
        case 0: vm.tmpStatus = 'order'; break;
        case 1: vm.tmpStatus = 'accepted'; break;
        case 2: vm.tmpStatus = 'partial'; break;
        case 3: vm.tmpStatus = 'declined'; break;
        case 4: vm.tmpStatus = 'completed'; break;
        default: vm.tmpStatus= 'order';
      }

      vm.fetchTransactionOrder({
        search: vm.search,
        id: "",
        offset: vm.page,
        limit: vm.itemsPerPage,
        sortBy: "created_at",
        sortDesc: 1,
        status: vm.tmpStatus,
        typeOrder:"sale_order",
        from_date: '',
        to_date:''
      });
    },
    currentPage(val) {
      let vm = this;

      vm.fetchTransactionOrder({
        search: vm.search,
        id: "",
        offset: val,
        limit: vm.itemsPerPage,
        sortBy: "created_at",
        sortDesc: 1,
        status: vm.tmpStatus,
        typeOrder:"sale_order",
        from_date: '',
        to_date:''
      });
    },
    search() {
      this.fetchDataTable();
    },

  },
  computed: {
    userDoc() {
      return this.$store.state.userDoc;
    }
  },
  created() {
    let vm = this;
    vm.itemsPerPage=12;
    vm.fetchCurrencyOption();
    vm.fetchTransactionOrder({
      search: vm.search,
      id: "",
      offset: vm.page,
      limit: vm.itemsPerPage,
      sortBy: "created_at",
      sortDesc: 1,
      status: "order",
      typeOrder:"sale_order",
      from_date: '',
      to_date: ''
    });
  }
};
</script>
